import { useKeycloak } from "@react-keycloak/web";
import { wait } from "@testing-library/user-event/dist/utils";
import AuthService from "services/AuthService";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserEmailToState } from "../redux/slices/postSlice";
import axios from 'axios';


const CheckUserInfo = async (companyName) => {
    var apiUrl = process.env.REACT_APP_API_URL;

    const resp = await axios.get(apiUrl + '/User/CheckUserInfo', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + window.localStorage.getItem('id_token')
        },
        params: {
            companyName: companyName
        }
    }).catch(err => {

        if (err.response.data.status === 400 || err.response.data.status === 403) {

            return false;
        }
    });

    if (resp != null && resp.status === 200) {

        return resp;
    }
    else {
        return false;
    }


}

const SecureRoute = ({ children }) => {
    const { keycloak } = useKeycloak();
    const isLoggedIn = keycloak.authenticated;

    var companyName = process.env.REACT_APP_LOCATION;
    var clientId = companyName === "toroslar"
        ? "osostoroslar-react"
        : companyName === "baskent"
            ? "ososbaskent-react"
            : companyName === "ayedas"
                ? "ososayedas-react"
                : ""

    const [isKeycloakLoggedIn, setIsKeycloakLoggedIn] = useState(false);

    const dispatch = useDispatch();
    const userEmail = useSelector((state) => state.app.userEmail);


    useEffect(() => {
        if (isLoggedIn !== undefined) {
            checkLogin(isLoggedIn);
        }
    }, [isLoggedIn]);



    const checkLogin = async (_isLoggedIn) => {

        if (_isLoggedIn) {

            dispatch(setUserEmailToState(keycloak?.idTokenParsed?.email));

            window.localStorage.setItem('userUID', keycloak.tokenParsed.sub);
            window.localStorage.setItem('id_token', keycloak.idToken);
            window.localStorage.setItem('userName', keycloak.tokenParsed.preferred_username);

            if (userEmail === '') {
                var response = await CheckUserInfo(process.env.REACT_APP_LOCATION);

                if (response !== false) {

                    setIsKeycloakLoggedIn(true);
                }
                else {
                    keycloak.logout();
                    alert("Bu sayfaya/bölge giriş yetkiniz bulunmamaktadır")
                }


            }


            else {
                setIsKeycloakLoggedIn(true);
            }







        }
        else {
            setIsKeycloakLoggedIn(false);
            window.localStorage.clear();
            var referrer = document.referrer === "" ? document.baseURI : document.referrer;

            // var keycloakUrl = process.env.REACT_APP_KEYCLOACK_URL;
            window.location.replace(process.env.REACT_APP_KEYCLOACK_URL + 'realms/OsosWeb/protocol/openid-connect/auth?client_id=' + clientId + '&redirect_uri=' + referrer + '&response_mode=fragment&response_type=code&scope=openid');
        }
    }


    return (<> {isKeycloakLoggedIn === true ? children : null}</>)
};

export default SecureRoute;